/**
 * Telefoonnummer-normalisatie voor consistente vergelijking.
 *
 * Klantnummers worden op verschillende plekken in verschillende formaten
 * opgeslagen ('0251 745 087', '06-12 34 56 78', '+31612345678',
 * '31612345678'). Voor het matchen (bv. een WhatsApp-gesprek aan een
 * project/lead koppelen) zetten we alles om naar hetzelfde E.164-achtige
 * NL-formaat (+31...), zodat opmaakverschillen niet meer uitmaken.
 */
export function normalizePhone(raw: string | null | undefined): string | null {
  if (!raw) return null;
  let c = raw.replace(/[\s\-().]/g, '');
  if (!c) return null;
  if (c.startsWith('00')) c = '+' + c.slice(2);
  if (c.startsWith('+')) return c;
  if (c.startsWith('0')) return '+31' + c.slice(1);
  if (c.startsWith('31')) return '+' + c;
  return '+' + c;
}
